import { createTheme } from "@mui/material";
import { common } from "@mui/material/colors";
import {
  blueGrey,
  green,
  red,
} from "@mui/material/colors";

const theme = createTheme({
  palette: {
    // 1. Un azul grisáceo como color primario, que evoca calma y modernidad.
    primary: {
      main: blueGrey[700], // Un azul grisáceo oscuro
      light: blueGrey[400],
      dark: blueGrey[900],
      contrastText: '#ffffff',
    },
    // 2. Un verde vibrante y enérgico como color secundario, que contrasta y crea dinamismo.
    secondary: {
      main: green['A700'], // Un verde brillante de la paleta de acento de Material-UI
      light: green['A200'],
      dark: green['A700'],
      contrastText: '#FFFFFF',
    },
    // 3. Colores semánticos para los estados.
    error: {
      main: red[500],
    },
    warning: {
      main: '#FFC107', // Amarillo para advertencias
    },
    info: {
      main: '#607D8B', // Un tono de azul grisáceo más claro para información
    },
    success: {
      main: green[600],
    },
    // 4. Fondos y texto
    background: {
      default: blueGrey[50], // Un azul grisáceo muy claro para un fondo suave
      paper: '#ffffff', // Blanco puro para las tarjetas y elementos
    },
    text: {
      primary: blueGrey[900], // Azul grisáceo muy oscuro para el texto
      secondary: blueGrey[600], // Gris medio para el texto secundario
      disabled: blueGrey[400],
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  // Opcional: añade más personalizaciones para un look consistente
  shape: {
    borderRadius: 12,
  },
});
// createTheme({
//   palette: {
//     // 1. Un azul claro como color principal, que evoca calma y modernidad.
//     primary: {
//       main: '#29B6F6', // Azul claro y brillante
//       light: '#6FEEFF',
//       dark: '#0086C4',
//       contrastText: '#FFFFFF',
//     },
//     // 2. Un naranja intenso para el color secundario, que contrasta y crea dinamismo.
//     secondary: {
//       main: '#FF5722', // Naranja intenso, casi un coral
//       light: '#FF8A50',
//       dark: '#C41C00',
//       contrastText: '#ffffff',
//     },
//     // 3. Colores semánticos para los estados.
//     error: {
//       main: red[500],
//     },
//     warning: {
//       main: '#FFD700', // Amarillo intenso para advertencias
//     },
//     info: {
//       main: '#80DEEA', // Cian claro para información
//     },
//     success: {
//       main: green[600],
//     },
//     // 4. Fondos y texto
//     background: {
//       default: '#f7fbffff', // Un azul muy claro para un fondo fresco
//       paper: '#FDFEFE', // Blanco casi puro para las tarjetas y elementos
//     },
//     text: {
//       primary: '#263238', // Un gris azulado muy oscuro para el texto
//       secondary: '#455A64', // Gris medio para el texto secundario
//       disabled: '#90A4AE',
//     },
//   },
//   typography: {
//     fontFamily: 'Poppins, sans-serif',
//   },
//   // Opcional: añade más personalizaciones para un look consistente
//   shape: {
//     borderRadius: 12,
//   },
// });

// createTheme({
//   palette: {
//     primary: {
//       main: "#1976d2",
//       contrastText: common.white,
//     },
//     success: {
//       main: "#2e7d32",
//       contrastText: common.white,
//     },
//     error: {
//       main: "#d32f2f",
//       contrastText: common.white,
//     },
//     warning: {
//       main: "#ed6c02",
//       contrastText: common.white,
//     },
//     info: {
//       main: "#0288d1",
//       contrastText: common.white,
//     },
//     secondary: {
//       main: "#9c27b0",
//       contrastText: "#181818",
//     },
//     contrastThreshold: 3,
//   },
//   typography: {
//     h1: {
//       color: "#181818",
//     },
//     h2: {
//       color: "#181818",
//       fontSize: "1.5rem",
//     },
//     h3: {
//       color: "#181818",
//     },
//     h4: {
//       color: "#181818",
//     },
//     h5: {
//       color: "#181818",
//     },
//     h6: {
//       color: "#181818",
//     },
//     body1: {
//       color: "#181818",
//     },
//     fontFamily: [
//       "Lato",
//       "Roboto",
//       "Helvetica Neue",
//       "Arial",
//       "sans-serif",
//     ].join(","),
//   },
//   components: {
//     MuiOutlinedInput: {
//       styleOverrides: {
//         input: {
//           "&::placeholder": {
//             fontSize: 14,
//             color: "#181818"
//           },
//         },
//       },
//     },
//     MuiMenuItem: {
//       styleOverrides: {
//         root: {
//           fontSize: 14
//         }
//       }
//     }
//   },
// });

export default theme;
